"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns a simulated Error response format for API's
 * @param {string} code
 * @param {string} msg
 * @returns {object}
 */
const notFoundErrorFactory = (code, msg) => {
    return {
        data: {
            code,
            desc: msg,
        },
        status: 404,
    };
};
exports.default = notFoundErrorFactory;
